import GradeLessonPage from '../components/GradeLessonPage';
import { apStatsData } from './data';

const APStatsPage = () => {
  return (
    <GradeLessonPage
      title="AP Statistics"
      subtitle="Master statistical analysis, data interpretation, and inference for the AP exam"
      description="Complete curriculum covering all 9 units: exploring data, sampling/experimentation, probability, random variables, sampling distributions, and statistical inference for proportions, means, chi-square, and regression slopes."
      data={apStatsData}
      gradientFrom="from-purple-600"
      gradientTo="to-pink-600"
    />
  );
};

export default APStatsPage;